<template>
  <footer class="text-body-secondary py-5">
    <div class="container">
      <p class="float-end mb-1">
        <a href="#">Back to top</a>
      </p>
      <p>
        おこぷれふぁんさいと(非公式) v.{{ appVersion }}
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION || '1.0.0';
    }
  }
}

</script>